import {Pipe, PipeTransform} from "@angular/core";
import {filter, some, toLower} from "lodash-es";

@Pipe({
  name: 'columnsFilter',
  standalone: true
})
export class ColumnsFilterPipe implements PipeTransform {
  transform(items: any[], searchTerm: string): any {
    if (!items) {
      return [];
    }
    if (!searchTerm) {
      return items;
    }
    searchTerm = searchTerm.toLowerCase();
    const results = filter(items, (object) => {
       return some(object, (value) => {
        // Check if the value (case-insensitive) includes the searchKey
         return  toLower(value).includes(searchTerm)
      });
    });
    return results;
  }
}
